import styled from 'styled-components';

export const Container = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const Title = styled.h2`
  font-size: 25px;
  width: 300px;
  margin-bottom: 20px;
`;
